import { ReactNode } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Icon, { IconType } from '@/components/view/atoms/icon/Icon'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  rightNode?: ReactNode
  subText?: ReactNode
  color?: TextColor
  noFill?: boolean
  bgColor?: 'secondary' | 'success'
  noRadius?: boolean
  noTopBorder?: boolean
  noPadding?: boolean
  onOpenCloseClick?(isOpening: boolean): void
  isOpening?: boolean
}

const Heading = ({
  children,
  rightNode,
  subText,
  color = TextColor.PRIMARY,
  bgColor,
  noRadius = false,
  noPadding = false,
  noTopBorder = false,
  onOpenCloseClick,
  isOpening = false
}: Props) => {
  return (
    <div
      className={clsx(
        'border-tertiary w-full',
        !noTopBorder && 'border-t-2',
        noPadding ? 'p-0' : 'px-3 pt-2',
        bgColor === 'secondary'
          ? 'bg-surface-secondary w-full'
          : bgColor === 'success'
            ? 'bg-surface-success'
            : '',
        !noRadius && 'rounded-t-xl'
      )}
    >
      <div className='border-secondary flex w-full items-center gap-x-1 border-b'>
        <div className='flex min-h-6.5 min-w-0 items-center p-3'>
          <Text size={16} weight={'bold'} lineHeight={150} tag='h2' color={color} fullWidth>
            {children}
            {subText && (
              <div className='mt-1'>
                <Text size={12} color={TextColor.SECONDARY}>
                  {subText}
                </Text>
              </div>
            )}
          </Text>
        </div>
        {(rightNode || onOpenCloseClick) && (
          <div className='mb-auto ml-auto flex items-center gap-2 pt-3 pr-3'>
            {rightNode}
            {onOpenCloseClick && (
              <Button
                square
                color={ButtonColor.SECONDARY}
                onClick={() => onOpenCloseClick(!isOpening)}
              >
                <Icon type={isOpening ? IconType.UP : IconType.DOWN} size={16} />
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Heading
